import { PageHeader } from '@/shared/components/PageHeader';
import { ClipboardList } from 'lucide-react';
import TaskTypesStep from '../components/TaskTypesStep';

export default function TaskTypesPage() {
  return (
    <div className="h-full flex flex-col bg-background overflow-hidden">
      <PageHeader
        title="Task Types"
        subtitle="Configure available task types and form assignments"
        icon={<ClipboardList className="w-7 h-7" style={{ color: '#E84A2B' }} />}
        breadcrumbs={[
          { label: 'Settings', href: '/settings' },
          { label: 'Task Types', current: true },
        ]}
      />
      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <TaskTypesStep />
      </div>
    </div>
  );
}
